import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/education-terms/EducationTermsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { EducationTermEditForm } from "./EducationTermEditForm";

export function EducationTermEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, educationTerm } = useSelector(
    (state) => ({
      actionsLoading: state.educationTerms.actionsLoading,
      isSuccess: state.educationTerms.isSuccess,
      type: state.educationTerms.type,
      educationTerm: state.educationTerms.educationTerm
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getEducationTerm(id));
    return () => dispatch(actions.cleanEducationTermsState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Eğitim Dönemi";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  
  const saveEducationTerm = (values) => {
    dispatch(actions.saveEducationTerm(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/egitim-donemleri`), 2500);
  };

  const btnRef = useRef();  
  const saveEducationTermClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };
  
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <EducationTermEditForm 
            educationTerm={educationTerm}
            btnRef={btnRef} 
            saveEducationTerm={saveEducationTerm}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveEducationTermClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}